import styled from "styled-components";
import { COLORS } from "../../../../../../layout/theme";

export const Inner = styled.div`
	border: 1px solid ${COLORS.Grey};
	border-radius: 5px;
	min-width: 200px;
	padding: 5px 10px;
`;

export const Container = styled.div`
	display: flex;
	gap: 15px;
	align-items: center;
`;
